<div class="border-b-2 border-neutral-300">
  <nav class="-mb-px flex space-x-8" aria-label="Tabs">
    @for (tab of tabs; track tab) {
      <button
        type="button"
        (click)="selectTab(tab)"
        [ngClass]="{
          'border-b-2 border-transparent': tab !== activeTab(),
          'border-b-2 border-primary-700': tab === activeTab(),
          'text-primary-700': tab === activeTab(),
        }"
        class="whitespace-nowrap cursor-pointer font-medium py-4 px-1 text-sm text-neutral-700 hover:text-primary-700 transition-all duration-300">
        {{ tab.title() }}
      </button>
    }
  </nav>
</div>
<div class="pt-4">
  @if (activeTab()) {
    <ng-container [ngTemplateOutlet]="activeTab()!.templateRef"></ng-container>
  }
</div>
